// src/pages/HistorialClinico.jsx
import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axios from 'axios';
import Breadcrumb from '../components/Breadcrumb';
import '../styles/HistorialClinico.css';
import { ToastContainer, toast } from 'react-toastify'; 
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';
import ModalConfirmacion from "../components/ModalConfirmacion";

import { AuthContext } from '../context/AuthContext';
import { useContext } from 'react';
import { useMemo } from 'react';
import { useRef, useLayoutEffect } from "react";

export default function HistorialClinico() {
  const { expediente } = useParams();
  const history = useHistory();
  const [actuaciones, setActuaciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [seleccionados, setSeleccionados] = useState([]);
  const [modoEdicion, setModoEdicion] = useState(false);
  const [nuevaFila, setNuevaFila] = useState(null);
  const [tratamientosDisponibles, setTratamientosDisponibles] = useState([]);
  const [modalAbierto, setModalAbierto] = useState(false);
  const [mensajeModal, setMensajeModal] = useState("");
  const [accionPendiente, setAccionPendiente] = useState(null);
  const [paciente, setPaciente] = useState(null);
  const [actuacionesBackup, setActuacionesBackup] = useState([]);
  const { roles } = useContext(AuthContext);
  const esAdmin = roles.includes("ADMIN");
  const tableRef = useRef(null);
  const [filaActiva, setFilaActiva] = useState(null);
  const [modalImprimir, setModalImprimir] = useState(false);

  const profesionalesOptions = [
    { value: "Maria", label: "Maria" },
    { value: "Lucia", label: "Lucia" },
    { value: "Barbara", label: "Barbara" },
    { value: "Alessandro", label: "Alessandro" },
    { value: "Ainhoa", label: "Ainhoa" },
    { value: "Paula", label: "Paula" }
  ];

  const actuacionesSeleccionadas = actuaciones.filter(act =>
    seleccionados.includes(act.id)
  );

  const formatFecha = (fecha) => {
    if (!fecha) return "";
    const [y, m, d] = fecha.split("-");
    return `${d}/${m}/${y}`;
  };

  const toggleSeleccion = (id) => {
    setSeleccionados(prev =>
      prev.includes(id)
        ? prev.filter(sel => sel !== id)
        : [...prev, id]
    );
  };

  const confirmarGuardar = () => {
    const tieneFactura = actuaciones.some(
      act => seleccionados.includes(act.id) && act.n_factura
    );

    if (tieneFactura) {
      setMensajeModal(
        "Estas actuaciones ya están facturadas. Si guardas los cambios se generará una FACTURA RECTIFICATIVA. ¿Deseas continuar?"
      );

      setAccionPendiente(() => () => procesarRectificativa());

      setModalAbierto(true);

    } else {
      // No facturadas ? solo guardar
      setMensajeModal("¿Deseas guardar los cambios?");
      setAccionPendiente(() => () => guardarSinFactura());
      setModalAbierto(true);
    }
  };

  const guardarSinFactura = async () => {
    try {
      await guardarCambios(); 
      toast.success("Cambios guardados");
    } finally {
      setModalAbierto(false);
    }
  };

  const confirmarEliminar = () => {
    const tieneFactura = actuaciones.some(
      act => seleccionados.includes(act.id) && act.n_factura
    );

    if (tieneFactura) {
      setMensajeModal(
        "Estas actuaciones ya están facturadas. Si las eliminas se generará una FACTURA ANULADA. ¿Deseas continuar?"
      );

      setAccionPendiente(() => () => procesarAnulada());
      setModalAbierto(true);

    } else {
      // borrar sin factura
      setMensajeModal("¿Seguro que quieres eliminar estas actuaciones?");
      setAccionPendiente(() => () => eliminarSinFactura());
      setModalAbierto(true);
    }
  };

  const eliminarSinFactura = async () => {
    try {
      await handleEliminar();
    } finally {
      setModalAbierto(false);
    }
  };


  const actualizarCampo = (id, campo, valor) => {
    setActuaciones(prev =>
      prev.map(act =>
        act.id === id ? { ...act, [campo]: valor } : act
      )
    );
  };

  const guardarCambios = async () => {
    try {
      // 1. Actualizar actuaciones existentes
      const actualizables = actuaciones.filter(act => seleccionados.includes(act.id));
      await axios.put('/api/actuaciones', actualizables, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });

      // 2. Crear nueva fila si existe
      if (nuevaFila) {
        await axios.post('/api/actuaciones', nuevaFila, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
      }

      // 3. Recargar datos
      const { data } = await axios.get(`/api/actuaciones/paciente/${expediente}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      setActuaciones(data);
      setSeleccionados([]);
      setModoEdicion(false);
      setNuevaFila(null);
    } catch (err) {
      console.error('Error al guardar cambios', err.response || err);
    }
  };

  const handleGuardarNueva = async () => {
    try {
      if (!nuevaFila.n_tratamiento) {
        toast.error("Falta el tratamiento, asegurate de seleccionarlo");
        return;
      } else if (!nuevaFila.dia) {
        toast.error("Falta la fecha");
        return;
      }
      const { data: nuevaActuacion } = await axios.post(`/api/actuaciones/paciente/${expediente}`, nuevaFila, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });

      setActuaciones([...actuaciones, nuevaActuacion]);
      setNuevaFila(null);
      toast.success(`Actuación guardada con ID: ${nuevaActuacion.id}`, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
    });
    } catch (error) {
      console.error("Error al guardar la actuación", error.response || error);
    }
  };

  const handleEliminar = async () => {
    try {
      await axios.delete('/api/actuaciones', {
        data: { ids: seleccionados },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });

      toast.success("Actuaciones eliminadas correctamente");
      const { data } = await axios.get(`/api/actuaciones/paciente/${expediente}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      setActuaciones(data);
      setSeleccionados([]);
    } catch (error) {
      toast.error("Error al eliminar actuaciones");
      console.error("Error al eliminar", error.response || error);
    }
  };

  const confirmarConFactura = (estado_factura) => {
    const actuacionesSeleccionadas = actuaciones.filter(act =>
      seleccionados.includes(act.id)
    );

    const items = actuacionesSeleccionadas.map(act => ({
      id: act.id,
      fecha: act.dia || new Date().toLocaleDateString('es-ES'),
      clave: act.clave,
      tratamiento: act.tratamiento,
      pieza: act.n_pieza,
      cuadrante: act.cuadrante,
      arcada: act.arcada,
      cantidad: act.cantidad || 1,
      precioUnitario: act.importe,
      total: (act.cantidad || 1) * (act.importe || 0)
    }));

    const datosFacturacion = {
      n_expediente: expediente,
      items,
      total: items.reduce((acc, i) => acc + i.total, 0),
      fecha: new Date().toISOString().slice(0, 10),
      nombre_cliente: `${paciente?.nombre} ${paciente?.primer_apellido} ${paciente?.segundo_apellido}`.trim(),
      nif: paciente?.nif,
      nif_emisor: "B88084215",
      estado_factura
    };

    axios.post("/api/facturacion/emitir", datosFacturacion, {
      responseType: "blob",
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
    })
    .then(async res => {

      // abrir PDF
      const url = window.URL.createObjectURL(
        new Blob([res.data], { type: "application/pdf" })
      );
      window.open(url, "_blank");

      toast.success(`Factura ${estado_factura} generada correctamente`);

      // recargar actuaciones
      const { data } = await axios.get(`/api/actuaciones/paciente/${expediente}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
      });
      setActuaciones(data);

      // reset UI
      setSeleccionados([]);
      setModoEdicion(false);
      setNuevaFila(null);
      setModalAbierto(false);

    })
    .catch(err => {
      console.error("Error al generar factura:", err);
      toast.error("Error al generar factura");
    });
  };

  const procesarAnulada = async () => {
    const actuacionesSeleccionadas = actuaciones.filter(act => seleccionados.includes(act.id));
    if (!actuacionesSeleccionadas.length) {
      toast.error("No hay actuaciones seleccionadas");
      setModalAbierto(false);
      return;
    }

    const facturaOriginal = actuacionesSeleccionadas[0].n_factura || "";
    const fechaOriginal = actuacionesSeleccionadas[0].fecha_factura || actuacionesSeleccionadas[0].dia || new Date().toISOString().slice(0,10);

    const items = actuacionesSeleccionadas.map(act => ({
      id: act.id,
      fecha: act.dia,
      profesional: act.profesional,
      clave: act.clave,
      tratamiento: act.tratamiento,
      pieza: act.n_pieza,
      cuadrante: act.cuadrante,
      arcada: act.arcada,
      cantidad: act.cantidad || 1,
      precioUnitario: act.importe,
      total: (act.cantidad || 1) * (act.importe || 0)
    }));

    const datosAnulacion = {
      n_expediente: expediente,
      items,
      total: items.reduce((a, i) => a + i.total, 0),
      fecha: new Date().toISOString().slice(0, 10),
      nombre_cliente: `${paciente.nombre} ${paciente.primer_apellido} ${paciente.segundo_apellido}`,
      nif: paciente.nif,
      nif_emisor: "B88084215",
      estado_factura: "ANULADA",
      factura_original: facturaOriginal,
      fecha_original: fechaOriginal
    };

    
    try {
      const res = await axios.post("/api/facturacion/emitir", datosAnulacion, {
        responseType: "arraybuffer",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/pdf"
        }
      });

      const blob = new Blob([res.data], { type: "application/pdf" });
      window.open(window.URL.createObjectURL(blob), "_blank");
      toast.success("Factura anulada generada");

      // si todo ok, borrar actuaciones en backend (si tu endpoint lo hace)
      await axios.delete('/api/actuaciones', {
        data: { ids: seleccionados },
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
      });

    } catch (err) {
      console.error("Error al anular:", err.response || err);
      toast.error("Error al generar factura anulada");
    } finally {
      setSeleccionados([]);
      setModoEdicion(false);
      setNuevaFila(null);
      setModalAbierto(false);

      // refrescar tabla
      try {
        const { data } = await axios.get(`/api/actuaciones/paciente/${expediente}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        });
        setActuaciones(data);
      } catch (e) {
        console.error("Error recargando actuaciones", e);
      }
    }
  };


  const procesarRectificativa = async () => {
    const actuacionesSeleccionadas = actuaciones.filter(act => seleccionados.includes(act.id));
    if (!actuacionesSeleccionadas.length) {
      toast.error("No hay actuaciones seleccionadas");
      setModalAbierto(false);
      return;
    }

    const facturaOriginal = actuacionesSeleccionadas[0].n_factura || "";
    const fechaOriginal = actuacionesSeleccionadas[0].fecha_factura || actuacionesSeleccionadas[0].dia || new Date().toISOString().slice(0,10);

    const items = actuacionesSeleccionadas.map(act => ({
      id: act.id,
      fecha: act.dia,
      profesional: act.profesional,
      clave: act.clave,
      tratamiento: act.tratamiento,
      pieza: act.n_pieza,
      cuadrante: act.cuadrante,
      arcada: act.arcada,
      cantidad: act.cantidad || 1,
      precioUnitario: act.importe,
      total: (act.cantidad || 1) * (act.importe || 0)
    }));

    // Datos para la ANULACIÓN (primero)
    const datosAnulacion = {
      n_expediente: expediente,
      items,
      total: items.reduce((a, i) => a + i.total, 0),
      fecha: new Date().toISOString().slice(0, 10),
      nombre_cliente: `${paciente.nombre} ${paciente.primer_apellido} ${paciente.segundo_apellido}`,
      nif: paciente.nif,
      nif_emisor: "B88084215",
      estado_factura: "ANULADA",
      factura_original: facturaOriginal,
      fecha_original: fechaOriginal
    };

    // Datos para la ALTA nueva (segunda petición)
    const datosAlta = {
      n_expediente: expediente,
      items,
      total: items.reduce((a, i) => a + i.total, 0),
      fecha: new Date().toISOString().slice(0, 10),
      nombre_cliente: `${paciente.nombre} ${paciente.primer_apellido} ${paciente.segundo_apellido}`,
      nif: paciente.nif,
      nif_emisor: "B88084215",
      // enviar algo distinto a "ANULADA" para que el backend trate como ALTA
      estado_factura: "ALTA",
      // opcional: factura_original y fecha_original no se envían en la ALTA nueva
    };

    try {
      // 1) Enviar ANULACIÓN a AEAT y abrir PDF de anulación
      const resAnul = await axios.post("/api/facturacion/emitir", datosAnulacion, {
        responseType: "arraybuffer",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/pdf"
        }
      });

      // abrir PDF de anulación
      const blobAnul = new Blob([resAnul.data], { type: "application/pdf" });
      window.open(window.URL.createObjectURL(blobAnul), "_blank");
      toast.success("Anulación enviada y PDF generado");

      // 2) Enviar ALTA nueva a AEAT y abrir PDF de la nueva factura
      const resAlta = await axios.post("/api/facturacion/emitir", datosAlta, {
        responseType: "arraybuffer",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/pdf"
        }
      });

      const blobAlta = new Blob([resAlta.data], { type: "application/pdf" });
      window.open(window.URL.createObjectURL(blobAlta), "_blank");
      toast.success("Factura rectificativa (alta nueva) generada");

      // 3) Guardar cambios locales en BBDD (actualiza actuaciones con la nueva factura)
      await guardarCambios();

    } catch (err) {
      console.error("Error en rectificativa:", err.response || err);
      toast.error("Error al procesar rectificativa. Revisa logs.");
    } finally {
      setSeleccionados([]);
      setModoEdicion(false);
      setNuevaFila(null);
      setModalAbierto(false);

      // refrescar tabla
      try {
        const { data } = await axios.get(`/api/actuaciones/paciente/${expediente}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        });
        setActuaciones(data);
      } catch (e) {
        console.error("Error recargando actuaciones", e);
      }
    }
  };
  const tratamientosOptions = useMemo(() => {
    return tratamientosDisponibles;
  }, [tratamientosDisponibles]);

  const imprimirHistorial = async (conObservaciones) => {
    const res = await axios.post(
      `/api/historial/imprimir/${expediente}`,
      { conObservaciones },
      {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      }
    );

    const blob = new Blob([res.data], { type: "application/pdf" });
    window.open(URL.createObjectURL(blob), "_blank");
  };

  useEffect(() => {
    async function fetchHistorial() {
      try {
        const { data } = await axios.get(
          `/api/actuaciones/paciente/${expediente}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }
        );
        setActuaciones(data);
      } catch (err) {
        console.error('Error al cargar historial', err.response || err);
      } finally {
        setLoading(false);
      }
    }

    fetchHistorial();
  }, [expediente]);


  useEffect(() => {
    async function fetchTratamientos() {
      const { data } = await axios.get('/api/tratamientos', {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });

      setTratamientosDisponibles(
        data.map(t => ({
          value: Number(t.n_tratamiento), // CLAVE
          label: `${t.denominacion} - ${t.importe.toFixed(2)} €`,
          denominacion: t.denominacion,
          importe: t.importe
        }))
      );
    }

    fetchTratamientos();
  }, []);


  useEffect(() => {
    async function fetchPaciente() {
      try {
        const { data } = await axios.get(`/api/pacientes/${expediente}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        setPaciente(data);
      } catch (err) {
        console.error("Error al cargar paciente:", err);
      }
    }

    fetchPaciente();
  }, [expediente]);

  const actualizarPagado = async (id, pagado) => {
    try {
      await axios.put(
        `/api/actuaciones/${id}/pagado`,
        null,
        {
          params: { pagado },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      );

      setActuaciones(prev =>
        prev.map(act =>
          act.id === id
            ? { ...act, pagado, pendiente_pago: pagado ? 0 : act.pendiente_pago }
            : act
        )
      );
    } catch (e) {
      console.error("Error actualizando pagado", e);
    }
  };

  const selectStyles = {
    container: (base) => ({
      ...base,
      minWidth: '360px',
      width: '100%',
    }),
    control: (base) => ({
      ...base,
      minHeight: '40px',
    }),
    menu: (base) => ({
      ...base,
      minWidth: '520px',
      width: 'auto',
    }),
    singleValue: (base) => ({
      ...base,
      whiteSpace: 'normal',
      lineHeight: '1.2',
    }),
    valueContainer: (base) => ({
      ...base,
      whiteSpace: 'normal',
      padding: '4px 8px',
    }),
  };

  
  if (loading) return <p>Cargando historial clínico…</p>;
  return (
    <>
      <ToastContainer />
        <div className="historial-clinico-page">
          <Breadcrumb />
          <h2>
            Historial clínico de{" "}
            {paciente
              ? [paciente.nombre, paciente.primer_apellido, paciente.segundo_apellido]
                  .filter(Boolean)        
                  .join(" ")
              : expediente}
          </h2>
          <div className="acciones-superiores">
            <button
              className="accion-btn"
              disabled={seleccionados.length === 0}
              onClick={() => {
                setActuacionesBackup(JSON.parse(JSON.stringify(actuaciones)));
                setModoEdicion(true);
              }}
            >
              Editar
            </button>
            <button
              className="accion-btn"
              onClick={() => setNuevaFila({
                dia: "",
                profesional: null,
                tratamientoSelect: null,
                n_tratamiento: null,
                tratamiento: "",
                importe: null,
                incidencias: "",
                n_pieza: "",
                cuadrante: "",
                arcada: "",
                cantidad: 1,
                realizado: 0,
                pagado: false,
                pendiente_pago: 0,
                n_presupuesto: ""
              })}
            >
              Añadir
            </button>
            {modoEdicion && (
              <button
                className="accion-btn guardar"
                onClick={guardarCambios}
              >
                Guardar cambios
              </button>
            )}
            {nuevaFila && (
              <button 
                className="accion-btn guardar"
                onClick={handleGuardarNueva}>
                  Guardar
              </button>
            )}
            {(modoEdicion || nuevaFila) && (
              <button
                className="accion-btn cancelar"
                onClick={() => {
                  setActuaciones(JSON.parse(JSON.stringify(actuacionesBackup)));
                  setModoEdicion(false);
                  setNuevaFila(null);
                  setSeleccionados([]);
                }}
              >
                Cancelar
              </button>
            )}
            <button
              className="accion-btn eliminar"
              disabled={seleccionados.length === 0}
              onClick={confirmarEliminar}
            >
              Eliminar
            </button>
          </div>
          <div className="tabla-scroll-container">
            <table className="historial-table" ref={tableRef}>
                <thead>
                  <tr>
                      <th></th>
                      <th>ID</th>
                      <th>Día</th>
                      <th>Profesional</th>
                      <th>Tratamiento</th>
                      <th>Observaciones</th>
                      <th>Pieza</th>
                      <th>Cuadrante</th>
                      <th>Arcada</th>
                      <th>Cantidad</th>
                      <th>Realizado</th>
                      <th>Pagado</th>
                      <th>Facturado</th>
                      <th>Nº Factura</th>
                      <th>Pendiente</th>
                      <th>Presupuesto</th>
                  </tr>
                </thead>
                <tbody>
                  {actuaciones.map(act => {
                    {/*  
                    if (esAdmin && Number(act.n_presupuesto) === 2) {
                      return null;
                    }
                    */}
                    const enEdicion = modoEdicion && seleccionados.includes(act.id);
                    return (
                      <tr 
                        key={act.id}
                        className={filaActiva === act.id ? 'fila-activa' : ''}
                        onClick={() => setFilaActiva(act.id)}
                        style={{ cursor: 'pointer' }}>
                        <td>
                          <input
                            type="checkbox"
                            checked={seleccionados.includes(act.id)}
                            onChange={() => toggleSeleccion(act.id)}
                          />
                        </td>
                        {enEdicion ? (
                          <>
                            <td>{act.id}</td>
                            <td> <input className="input-campo" type="date" value={act.dia} onChange={e => actualizarCampo(act.id, 'dia', e.target.value)} /></td>
                            <td>
                              <Select
                                options={profesionalesOptions}
                                value={profesionalesOptions.find(p => p.value === act.profesional) || null}
                                onChange={(opcion) =>
                                  actualizarCampo(act.id, "profesional", opcion ? opcion.value : null)
                                }
                                isClearable
                              />
                            </td>
                            <td>
                              <Select
                                className="select-tratamiento"
                                classNamePrefix="react-select"
                                menuPortalTarget={document.body}
                                styles={selectStyles}
                                options={tratamientosDisponibles}
                                value={
                                  tratamientosDisponibles.find(
                                    t => t.value === act.n_tratamiento
                                  ) || null
                                }
                                onChange={(opcion) => {
                                  actualizarCampo(act.id, 'n_tratamiento', opcion ? opcion.value : null);
                                  actualizarCampo(act.id, 'tratamiento', opcion ? opcion.denominacion : '');
                                  actualizarCampo(act.id, 'importe', opcion ? opcion.importe : null);
                                }}
                                isClearable
                              />
                            </td>
                            <td><textarea className="textarea-auto" value={act.incidencias || ""} onChange={e => {
                                actualizarCampo(act.id, "incidencias", e.target.value);
                                e.target.style.height = "auto";
                                e.target.style.height = (e.target.scrollHeight) + "px";
                              }} />
                            </td>
                            <td><input className="input-campo" value={act.n_pieza} onChange={e => actualizarCampo(act.id, 'n_pieza', e.target.value)} /></td>
                            <td><input className="input-campo" value={act.cuadrante} onChange={e => actualizarCampo(act.id, 'cuadrante', e.target.value)} /></td>
                            <td><input className="input-campo" value={act.arcada} onChange={e => actualizarCampo(act.id, 'arcada', e.target.value)} /></td>
                            <td><input className="input-campo" value={act.cantidad} onChange={e => actualizarCampo(act.id, 'cantidad', e.target.value)} /></td>
                            <td><input className="input-campo" type="checkbox" checked={act.realizado} onChange={e => actualizarCampo(act.id, 'realizado', e.target.checked ? 1 : 0)} /></td>
                            <td>
                              <input
                                type="checkbox"
                                checked={act.pagado}
                                onChange={e => actualizarPagado(act.id, e.target.checked)}
                              />
                            </td>
                            <td>{act.n_factura ? 'Sí' : 'No'}</td>
                            <td>{act.n_factura}</td>
                            <td><input className="input-campo" value={act.pendiente_pago} onChange={e => actualizarCampo(act.id, 'pendiente_pago', e.target.value)} /></td>
                            <td><input className="input-campo" value={act.n_presupuesto} onChange={e => actualizarCampo(act.id, 'n_presupuesto', e.target.value)} /></td>
                          </>
                        ) : (
                          <>
                            <td>{act.id}</td>
                            <td>{formatFecha(act.dia)}</td>
                            <td>{act.profesional}</td>
                            <td>
                              {(() => {
                                const tratPorId = tratamientosDisponibles.find(
                                  t => Number(t.value) === Number(act.n_tratamiento)
                                );

                                if (tratPorId) return tratPorId.label;

                                const tratPorNombre = tratamientosDisponibles.find(
                                  t => t.denominacion === act.tratamiento
                                );

                                return tratPorNombre
                                  ? `${tratPorNombre.denominacion} - ${tratPorNombre.importe.toFixed(2)} €`
                                  : act.tratamiento;
                              })()}
                            </td>
                            <td>{act.incidencias}</td>
                            <td>{act.n_pieza}</td>
                            <td>{act.cuadrante}</td>
                            <td>{act.arcada}</td>
                            <td>{act.cantidad}</td>
                            <td>
                                <span className={act.realizado ? 'color-si' : 'color-no'}>
                                    {act.realizado ? 'Sí' : 'No'}
                                </span>
                            </td>
                            <td>
                              <span className={act.pagado ? 'color-si' : 'color-no'}>
                                    {act.pagado ? 'Sí' : 'No'}
                              </span>
                            </td>
                            <td>
                                <span className={act.n_factura ? 'color-si' : 'color-no'}>
                                    {act.n_factura ? 'Sí' : 'No'}
                                </span>
                            </td>
                            <td>{act.n_factura}</td>
                            <td>{act.pendiente_pago}</td>
                            <td>{act.n_presupuesto}</td>
                          </>
                        )}
                      </tr>
                    );
                  })}

                  {nuevaFila && (
                    <tr key="nueva">
                      <td></td>
                      <td>Nuevo</td>
                      <td><input className="input-campo" type="date" value={nuevaFila.dia} onChange={e => setNuevaFila({ ...nuevaFila, dia: e.target.value })} /></td>
                      <td>
                        <Select
                          options={profesionalesOptions}
                          value={profesionalesOptions.find(p => p.value === nuevaFila.profesional) || null}
                          onChange={(opcion) =>
                            setNuevaFila({ ...nuevaFila, profesional: opcion ? opcion.value : null })
                          }
                          placeholder="Profesional"
                        />
                      </td>
                      <td>
                        <Select
                          className="select-tratamiento"
                          classNamePrefix="react-select"
                          menuPortalTarget={document.body}
                          styles={selectStyles}
                          options={tratamientosDisponibles}
                          value={nuevaFila.tratamientoSelect
                          }
                          onChange={(opcion) => {
                            setNuevaFila(prev => ({
                              ...prev,
                              tratamientoSelect: opcion,
                              n_tratamiento: opcion ? Number(opcion.value) : null,
                              tratamiento: opcion ? opcion.denominacion : '',
                              importe: opcion ? opcion.importe : null
                            }));
                          }}
                          placeholder="Seleccionar tratamiento"
                          isClearable
                        />
                      </td>
                      <td><textarea className="textarea-auto" value={nuevaFila.incidencias || ""} onChange={e => {
                                setNuevaFila({ ...nuevaFila, incidencias: e.target.value });
                                e.target.style.height = "auto";
                                e.target.style.height = (e.target.scrollHeight) + "px";
                              }} />
                      </td>             
                      <td><input className="input-campo" value={nuevaFila.n_pieza} onChange={e => setNuevaFila({ ...nuevaFila, n_pieza: e.target.value })} /></td>
                      <td><input className="input-campo" value={nuevaFila.cuadrante} onChange={e => setNuevaFila({ ...nuevaFila, cuadrante: e.target.value })} /></td>
                      <td><input className="input-campo" value={nuevaFila.arcada} onChange={e => setNuevaFila({ ...nuevaFila, arcada: e.target.value })} /></td>
                      <td><input className="input-campo" value={nuevaFila.cantidad} onChange={e => setNuevaFila({ ...nuevaFila, cantidad: e.target.value })} /></td>
                      <td><input className="input-campo" type="checkbox" checked={nuevaFila.realizado} onChange={e => setNuevaFila({ ...nuevaFila, realizado: e.target.checked ? 1 : 0})} /></td>
                      <td><input className="input-campo" type="checkbox" checked={nuevaFila.pagado} onChange={e => setNuevaFila({ ...nuevaFila, pagado: e.target.checked ? 1 : 0})} /></td>
                      <td></td>
                      <td></td>
                      <td><input className="input-campo" value={nuevaFila.pendiente_pago} onChange={e => setNuevaFila({ ...nuevaFila, pendiente_pago: Number(e.target.value) })} /></td>
                      <td><input className="input-campo" value={nuevaFila.n_presupuesto} onChange={e => setNuevaFila({ ...nuevaFila, n_presupuesto: e.target.value })} /></td>
                    </tr>
                  )}
                </tbody>
            </table>
          </div>
          <div className="acciones-inferiores">
            <button
              className="accion-btn odontograma"
              onClick={() => history.push(`/pacientes/${expediente}/historial-clinico/odontograma`)}
            >
              Odontograma
            </button>
            <button
              className="accion-btn presupuesto"
              disabled={seleccionados.length === 0}
              onClick={() => {
                const seleccionadas = actuaciones.filter(act => seleccionados.includes(act.id));
                history.push(`/presupuesto`, { actuaciones: seleccionadas, expediente: expediente });
              }}
            >
              Realizar presupuesto
            </button>
            {/*<button
              className="accion-btn estado"
              disabled={seleccionados.length === 0}
              onClick={() => console.log('Estado de tratamientos')}
            >
              Estado de tratamientos
            </button> */}
            <button
              className="accion-btn facturar"
              disabled={seleccionados.length === 0}
              onClick={() => {
                const seleccionadas = actuaciones.filter(act => seleccionados.includes(act.id));
                history.push(`/facturacion`, { 
                  actuaciones: seleccionadas, 
                  expediente,
                  pacienteNombre: `${paciente?.nombre} ${paciente?.primer_apellido} ${paciente?.segundo_apellido}`.trim(),
                  pacienteNif: paciente.nif
                });
              }}
            >
              Facturar
            </button>
            <button
              className="accion-btn"
              onClick={() => {
                setMensajeModal("¿Cómo deseas imprimir el historial clínico?");
                setAccionPendiente(null);
                setModalImprimir(true);
              }}
            >
              Imprimir historial
            </button>
            <button
              className="accion-btn"
              onClick={() => history.push(`/pacientes/${expediente}`)}
            >
              Volver al paciente
            </button>
          </div>
        </div>
      <ModalConfirmacion  
        abierto={modalImprimir}
        mensaje="¿Cómo deseas imprimir el historial clínico?"
        textoConfirmar="Con observaciones"
        textoSecundario="Sin observaciones"
        onConfirmar={() => {
          setModalImprimir(false);
          imprimirHistorial(true);
        }}
        onSecundario={() => {
          setModalImprimir(false);
          imprimirHistorial(false);
        }}
        onCancelar={() => setModalImprimir(false)}
      />
      <ModalConfirmacion
        abierto={modalAbierto}
        mensaje={mensajeModal}
        onConfirmar={() => {
          setModalAbierto(false);
          if (accionPendiente) accionPendiente();
        }}
        onCancelar={() => setModalAbierto(false)}
      />
    </>
  );
}